import { render, staticRenderFns } from "./SanitizedHtml.vue?vue&type=template&id=d6446050&"
import script from "./SanitizedHtml.vue?vue&type=script&lang=js&"
export * from "./SanitizedHtml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports